import { Tr, Td, IconButton, HStack } from "@chakra-ui/react";
import React from "react";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";

// Helper function to format hours (convert "00:00" to "0h", "160:00" to "160h")
const formatHours = (hoursString) => {
  if (!hoursString || hoursString === "00:00" || hoursString === "0") return "0h";
  if (hoursString.includes(":")) {
    const [hours] = hoursString.split(":");
    const hoursNum = parseInt(hours);
    return hoursNum > 0 ? `${hoursNum}h` : "0h";
  }
  const num = parseInt(hoursString);
  return isNaN(num) ? hoursString : `${num}h`;
};

// Helper function to format currency
const formatCurrency = (value) => {
  if (!value || value === "0" || value === "0.00") return "₦0";
  const numValue = parseFloat(value.toString().replace(/,/g, ''));
  if (isNaN(numValue)) return value;
  // Show decimals only if not a whole number
  if (numValue % 1 === 0) {
    return `₦${numValue.toLocaleString('en-US')}`;
  }
  return `₦${numValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const ListOfPayrol = ({
  fullName,
  employee_id,
  department,
  branch_name,
  hourlySalary,
  totalHoursWorked,
  overtimeHours,
  missedHours,
  regularPayGross,
  overtimePay,
  missedHoursDeduction,
  leaveAllowance,
  bonus,
  totalPayGross,
  regularPayTax,
  totalPayTax,
  deductions,
  totalPayNet,
  regularNetSalary,
  isExpanded,
  onToggle,
}) => {
  return (
    <Tr 
      cursor="pointer" 
      _hover={{ bg: "gray.50" }}
      onClick={onToggle}
    >
      <Td>
        <IconButton
          icon={isExpanded ? <FiChevronDown /> : <FiChevronRight />}
          variant="ghost"
          size="sm"
          aria-label="Toggle details"
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        />
      </Td>
      <Td fontWeight="600">{fullName} ({employee_id})</Td>
      <Td>{department}</Td>
      <Td>{branch_name || 'Unknown Branch'}</Td>
      <Td>{formatCurrency(regularPayGross)}</Td>
      <Td fontWeight="600">{formatCurrency(totalPayGross)}</Td>
      <Td fontWeight="500" color="red.500">
        {formatCurrency(regularPayTax)}
      </Td>
      <Td fontWeight="500" color="red.500">
        {formatCurrency(totalPayTax)}
      </Td>
      <Td fontWeight="500" color="red.500">
        {formatCurrency(deductions || 0)}
      </Td>
      <Td fontWeight="700" color="green.600" fontSize="md">
        {formatCurrency(totalPayNet)}
      </Td>
      <Td fontWeight="600" color="blue.600">
        {formatCurrency(regularNetSalary)}
      </Td>
    </Tr>
  );
};

export default ListOfPayrol;
